import React, { useEffect } from "react";

import useTranslations from "containers/hooks/useLanguageHook";
import { useContentSize } from "containers/hooks/useWindowSize";
import SunBurst from "containers/Visuals/SunBurst";
import { setSidebarFilter } from "@store/filters/actions";
import { FilterType } from "@store/filters/types";
import { useAppDispatch, useAppSelector } from "index";
import { setCurrentVisualization } from "@store/options/actions";
import { VisTypes } from "@store/options/types";
import { VisPageWrapper } from "@pages/VisPageWrapper";
import { Grid } from "@mui/material";
import { calculateGridItemSize } from "@utils/format";
import { GridSize } from "@mui/material/Grid";
import MultipleViewTitleGrid from "../Components/MultipleViewTitleGrid";
import { getProvider } from "../../fileParsing/definitions";
import { switchActive } from "@store/data/actions";
import { ApplicationState } from "@store/index";
const SunburstImage = new URL("../../../public/sunburst.png", import.meta.url).href;

function SunburstPage() {
  const { width, height } = useContentSize();
  const { t } = useTranslations();
  const dispatch = useAppDispatch();

  const options = useAppSelector((state: ApplicationState) => state.options.options);
  const providerItems = useAppSelector((state: ApplicationState) => state.data.exports);

  const activeExports = providerItems.filter((d) => d.active);

  useEffect(() => {
    dispatch(setSidebarFilter([FilterType.categories]));
    dispatch(setCurrentVisualization(VisTypes.Sunburst));
  }, []);

  return (
    <VisPageWrapper
      title={t.Vis.SunBurst}
      help={{
        title: t.LandingPage.SunBurstTitle,
        description: t.LandingPage.SunBurstText,
        image: SunburstImage,
      }}
    >
      {options.MultipleViews.value && activeExports.length > 1 ? (
        <Grid container spacing={1}>
          {activeExports.map((d, i, list) => (
            <Grid item xs={calculateGridItemSize(list.length) as GridSize} key={d.id}>
              <MultipleViewTitleGrid
                fileName={d.fileProperties.fileName}
                providerName={d.providerId === "wrangled" ? t.DataPage.UnknownProvider : getProvider(d.providerId).name}
                handleHide={() => dispatch(switchActive(d.id))}
              />
              <SunBurst
                exportId={d.id}
                size={{
                  height: `calc(${height / 2 - 28}px)`,
                  width: "100%",
                }}
              />
            </Grid>
          ))}
        </Grid>
      ) : (
        <SunBurst
          settings={{
            width,
            height,
          }}
          size={{
            width,
            height,
          }}
        />
      )}
    </VisPageWrapper>
  );
}

export { SunburstPage };
